import { render, staticRenderFns } from "./FaceAuthResult.vue?vue&type=template&id=7f95eb8a&scoped=true"
import script from "./FaceAuthResult.vue?vue&type=script&lang=js"
export * from "./FaceAuthResult.vue?vue&type=script&lang=js"
import style0 from "./FaceAuthResult.vue?vue&type=style&index=0&id=7f95eb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f95eb8a",
  null
  
)

export default component.exports